











import queryString from 'query-string'
import Vue from 'vue'

import { client } from '@/services/ApiClient'

export default Vue.extend({
  name: 'Callback',

  beforeRouteEnter(_to, _from, next) {
    next((vm: Vue & { checkCallback?: () => Promise<void> }) => {
      if (vm.$root.$data.isLoggedIn) {
        vm.$router.replace({ path: '/' })
      } else {
        vm.checkCallback && vm.checkCallback()
      }
    })
  },

  methods: {
    async checkCallback() {
      const hash = queryString.parse(location.hash)
      const state = hash?.state as string | undefined
      const jwt = hash?.id_token as string | undefined
      const stateMatches = (state?: string): boolean =>
        !!state &&
        document.cookie
          .split('; ')
          .find(row => row.startsWith('auth-state'))
          ?.split('=')[1] === state

      const isLoggedIn = !!jwt && stateMatches(state)
      if (!isLoggedIn) {
        this.$root.$data.user = null
        this.$root.$data.isLoggedIn = false
        // redirect to log in
        await this.$router.replace({ name: 'Login' })

        return
      }

      // remove auth state cookie
      document.cookie = `auth-state=${state};max-age=0;path=/`

      // add token to new cookie
      document.cookie = `auth-token=${jwt};path=/`

      this.$root.$data.isLoggedIn = true
      client.whoAmI().then(u => {
        this.$root.$data.user = u
      })

      // noinspection ES6MissingAwait
      this.$router.replace({ name: 'Pay slips' })
    },
  },
})
